import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Button, CardCompanySelect } from "@ficatranquilo/contabilidade.com-ui";
import useService from "@hooks/useService";
import RoleTag from "@components/RoleTag";
import { safeReturnTo, setActiveCompanyId } from "@helpers/activeCompany";
import { PublicBox, PublicLoading, PublicPage } from "../Common/PublicPage";
import useLogoutApp from "./useLogoutApp";

export default function CompanySelect() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  // Tela que pediu a seleção (a API recusou por falta de empresa ativa)
  const returnTo = safeReturnTo(searchParams.get("returnTo")) || "/";
  const authService = useService("auth");
  const logoutApp = useLogoutApp();
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [failed, setFailed] = useState(false);

  async function loadCompanies() {
    setLoading(true);
    setFailed(false);
    try {
      const me = await authService.me("complete=1");
      if (me?.data?.companies) {
        setCompanies(me.data.companies);

        if (me.data.companies.length === 1) {
          selectCompany(me.data.companies[0]);
          return;
        }
      } else {
        setFailed(true);
      }
    } catch (err) {
      console.error(err);
      setFailed(true);
    }
    setLoading(false);
  }

  useEffect(() => {
    loadCompanies();
  }, []);

  function selectCompany(company) {
    setActiveCompanyId(company.companyId);
    // Área de empresa (/c) ou de colaborador (/e) só volta se o papel na empresa
    // escolhida bater; senão cairia em "não autorizado"
    const wrongArea =
      (returnTo.startsWith("/c/") && company.role !== "ADM") ||
      (returnTo.startsWith("/e/") && company.role !== "EMP");
    navigate(wrongArea ? "/" : returnTo);
  }

  if (loading) {
    return <PublicLoading text="Carregando suas empresas" />;
  }

  if (failed) {
    return (
      <PublicPage
        title="Não foi possível carregar suas empresas"
        description="Confira sua conexão e tente de novo."
        actions={
          <>
            <Button $text="Sair" $variant="outline" $action={logoutApp} />
            <Button $text="Tentar novamente" $variant="primary" $action={loadCompanies} />
          </>
        }
      />
    );
  }

  if (companies.length === 0) {
    return (
      <PublicPage
        title="Você ainda não está vinculado a nenhuma empresa"
        description="Entre em contato com o administrador da empresa para receber um convite."
        actions={<Button $text="Sair" $variant="outline" $action={logoutApp} />}
      />
    );
  }

  return (
    <PublicPage title="Selecione uma empresa">
      <PublicBox>
        {companies.map((company) => (
          <CardCompanySelect
            key={company.companyId}
            tag={<RoleTag role={company.role} />}
            surname={company.companyName || ""}
            identification={company.cnpj || ""}
            action={() => selectCompany(company)}
          />
        ))}
      </PublicBox>
    </PublicPage>
  );
}
